import { render, staticRenderFns } from "./modalAttachCompany.vue?vue&type=template&id=afd57bd0&"
import script from "./modalAttachCompany.vue?vue&type=script&lang=js&"
export * from "./modalAttachCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports